import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { StructureList } from '../../shared/models/structure-list';
import { HistoryService } from '../history.service';
import { DetailPageBase } from '../../shared/components/detailpage-base/detail-page-base';
import { SettingsService } from '../../shared/settings/settings.service';
import { DocumentService } from '../../shared/services/document.service';
import { WebdokuService } from '../../web-doku/webdoku.service';
import { LdwRouterService } from '../../route/ldw-router.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectionArguments } from '../../shared/models/selection-arguments';
import { SelectionType } from '../../shared/enums/selection-type';
import { InfoService } from '../../shared/services/info.service';
import { switchMap, take, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'ldw-info-history',
    templateUrl: './info-history.component.html',
    styleUrls: ['./info-history.component.css'],
    standalone: false
})
export class InfoHistoryComponent extends DetailPageBase implements OnInit, OnDestroy {
  private historyService = inject(HistoryService);


  constructor() {
    const settingsService = inject(SettingsService);
    const documentService = inject(DocumentService);
    const webdokuService = inject(WebdokuService);
    const routerService = inject(LdwRouterService);
    const route = inject(ActivatedRoute);
    const router = inject(Router);
    const infoService = inject(InfoService);

    super(settingsService, documentService, webdokuService, routerService, route, router, infoService, false);
  }

  ngOnInit(): void {
    this.wdSubscription.add(
      this.route.paramMap.subscribe((params) => {
        const wd = params.get('wd') ?? '';
        this.webdokuService
          .selectWebDoku(wd)
          .pipe(
            switchMap((selectWdOk) => this.getHistory(selectWdOk)),
            take(1)
          )
          .subscribe();
      })
    );
  }

  getHistory(selectWdOk: boolean): Observable<StructureList> {
    if (selectWdOk) {
      return this.historyService.get().pipe(
        tap((res) => {
          this.documents = res;
          // this.infoService.clearStatus();
          this.infoService.setLoadedItems(this.documents.data.length);
          this.showNoData = true;
        })
      );
    } else {
      this.showNoData = false;
      this.documents = new StructureList();
      this.infoService.setStatus(`can't activate`);
      return of(this.documents);
    }
  }

  ngOnDestroy(): void {
    this.wdSubscription.unsubscribe();
  }

  hasHistoryData(): boolean {
    return this.documents?.data?.length > 0;
  }

  clearHistory() {
    this.historyService.clear().subscribe((success) => {
      if (success) {
        this.documents.data = [];
        this.infoService.clearStatus();
      }
    });
  }

  itemSelected(args: SelectionArguments) {
    if (args == undefined || args.id == undefined) {
      return;
    }

    if (args.action == SelectionType.Selected) {
      this.routerService.navigateToDocumentViewer(args.id);
      return;
    }

    if (args.action == SelectionType.Preview) {
      this.activateInternalEditorView(args.id);
      return;
    }

    if (args.action == SelectionType.Edit) {
      this.routerService.navigateToDocumentEditor(args.id);
      return;
    }

    if (args.action == SelectionType.History) {
      this.routerService.navigateToDocHistory(args.id);
    }
  }
}
